import { getApiBaseUrl } from 'apps/sigma2-ui/src/constants/environment';
import { UserAuthenticatedApiCall } from 'apps/sigma2-ui/src/state/user-types';
import { DashboardAISummaryDto } from 'libs/end-to-end/src/dashboard-ai-summary/dashboard-ai-summary-types';
import { GenerateDashboardAISummaryControllerResult } from 'libs/end-to-end/src/generate-dashboard-ai-summary';
import { GenerateDashboardAISummaryRequest } from 'libs/end-to-end/src/generate-dashboard-ai-summary';

export const callCreateDashboardAISummary = async ({
  organizationId,
  databaseId,
  databaseRevisionId,
  dashboardId,
  requestBody,
  userAuthenticatedApiCall,
}: {
  organizationId: string;
  databaseId: string;
  databaseRevisionId: string;
  dashboardId: string;
  requestBody: GenerateDashboardAISummaryRequest;
  userAuthenticatedApiCall: UserAuthenticatedApiCall;
}): Promise<GenerateDashboardAISummaryControllerResult | null> => {
  const result = await userAuthenticatedApiCall({
    url: `${getApiBaseUrl()}/organizations/${organizationId}/databases/${databaseId}/revisions/${databaseRevisionId}/dashboards/${dashboardId}/dashboard-ai-summary`,
    requestOptions: {
      method: 'POST',
      body: JSON.stringify(requestBody),
    },
    responseSchema: GenerateDashboardAISummaryControllerResult,
  });

  if (!result || result.resultType === 'err') {
    return null;
  }

  return result.value;
};

export const callQueryDashboardAISummary = async ({
  organizationId,
  databaseId,
  databaseRevisionId,
  dashboardId,
  dashboardAISummaryId,
  userAuthenticatedApiCall,
}: {
  organizationId: string;
  databaseId: string;
  databaseRevisionId: string;
  dashboardId: string;
  dashboardAISummaryId: string;
  userAuthenticatedApiCall: UserAuthenticatedApiCall;
}): Promise<DashboardAISummaryDto | null> => {
  const result = await userAuthenticatedApiCall({
    url: `${getApiBaseUrl()}/organizations/${organizationId}/databases/${databaseId}/revisions/${databaseRevisionId}/dashboards/${dashboardId}/dashboard-ai-summary/${dashboardAISummaryId}`,
    requestOptions: {
      method: 'GET',
    },
    responseSchema: DashboardAISummaryDto,
  });

  if (!result || result.resultType === 'err') {
    return null;
  }

  return result.value;
};
